import { useEffect, useState } from 'react';
import { tryFetch } from 'Helpers/FetchAPI'; 

export const useKeywords = () => {
  const [keywords, setKeywords] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchKeywords = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await tryFetch({
          url: '/merchants',
          method: 'GET',
        });

        if (response.is_success && Array.isArray(response.data)) {
          const extractedKeywords = response.data
            .flatMap((merchant: any) =>
              merchant.keywords
                ? merchant.keywords.split(',').map((kw: string) => kw.trim())
                : []
            );

          const uniqueKeywords = Array.from(new Set(extractedKeywords)).filter(Boolean);

          setKeywords(uniqueKeywords);
        } else {
          setError('Failed to fetch merchant keywords.');
        }
      } catch (err) {
        console.error(err);
        setError('An error occurred while fetching keywords.');
      } finally {
        setLoading(false);
      }
    };

    fetchKeywords();
  }, []);

  return { keywords, loading, error };
};
